export default '/v2/project';
